module.exports = __webpack_public_path__ + "img/益视说明书_18.477a8d50.png";